/**
 * SQL 포매터 옵션 빌더 (Phase 3)
 *
 * 배경: 코드가 sql-formatter v4 옵션(`uppercase`, `indent`)을 넘기고 있었는데
 * 설치된 버전은 v15 라 **둘 다 조용히 무시**됐다. 에러가 안 나서 눈치채기 어려웠고,
 * 결과적으로 "포맷" 을 눌러도 키워드가 대문자로 바뀌지 않고 들여쓰기도 2칸이었다.
 * 여기서 v15 옵션으로 정규화하고, 값은 설정(appSettings.sqlFormat)에서 받는다.
 */
import { format } from 'sql-formatter';
import { loadSection } from './appSettings';

/**
 * 설정 → sql-formatter v15 옵션.
 * @param {object} [override] - linesBetweenQueries 등 호출부에서 덮어쓸 값
 */
export function buildFormatOptions(override = {}) {
  const s = loadSection('sqlFormat') || {};
  const opts = {
    language: s.language || 'plsql',
    keywordCase: s.keywordCase || 'upper',
    tabWidth: Number(s.tabWidth) > 0 ? Number(s.tabWidth) : 4,
    linesBetweenQueries: Number.isFinite(Number(s.linesBetweenQueries)) ? Number(s.linesBetweenQueries) : 1,
    logicalOperatorNewline: s.logicalOperatorNewline || 'before',
    expressionWidth: Number(s.expressionWidth) > 0 ? Number(s.expressionWidth) : 50,
    denseOperators: !!s.denseOperators,
    newlineBeforeSemicolon: !!s.newlineBeforeSemicolon,
    ...override,
  };
  return opts;
}

/**
 * 「쿼리 보기」 표시용 포맷 — 에디터의 포맷 기능과 **같은 포매터·같은 설정**(buildFormatOptions)이다.
 * 서버가 주는 SQL(실제로 도는 문자열)은 그대로 두고 보일 때만 바꾼다. 포매터가 못 읽는 구문이면 던지지 않고
 * 원문을 돌려준다(ok:false) — 화면은 그 사실을 말하고 원문을 보인다.
 */
export function formatSqlForDisplay(sql) {
  const text = String(sql ?? '');
  if (!text.trim()) return { ok: true, text };
  try {
    return { ok: true, text: format(text, buildFormatOptions()) };
  } catch (err) {
    return { ok: false, text, error: err && err.message };
  }
}
